{
  "ru": {
    "title": "Серия документа",
    "examplesTitle": "Примеры",
    "firstExample": "две буквы: AB1234567 → серия \"AB\"",
    "secondExample": "одна буква: B1234567 → серия \"B\"",
    "thirdExample": "две цифры: 12 345678 → серия \"12\"",
    "fourthExample": "одна цифра: 1 2345678 → серия \"1\"",
    "close": "Закрыть"
  },
  "kk": {
    "title": "Құжаттың сериясы",
    "examplesTitle": "Мысалдар",
    "firstExample": "екі әріп: AB1234567 → \"AB\" сериясы",
    "secondExample": "бір әріп: B1234567 → \"B\" сериясы",
    "thirdExample": "екі цифр: 12 345678 → \"12\" сериясы",
    "fourthExample": "бір цифр: 1 2345678 → \"1\" сериясы",
    "close": "Жабу"
  },
  "en": {
    "title": "Document series",
    "examplesTitle": "Examples",
    "firstExample": "two letters: AB1234567 → series \"AB\"",
    "secondExample": "one letter: B1234567 → series \"B\"",
    "thirdExample": "two numbers: 12 345678 → series \"12\"",
    "fourthExample": "one number: 1 2345678 → series \"1\"",
    "close": "Close"
  }
}
